// TSS vite/03 §"Query keys convention".

export const raceKeys = {
    all:    ['races'],
    list:   (filters) => ['races', 'list', filters],
    detail: (id)      => ['races', 'detail', id],
};
